import React, { useState, useEffect } from "react";
import "./FakeIndi.scss"
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import TableDoc from "../../component/TableDoc/TableDoc";
import TableForm from "../../component/TableForm/TableForm";
// import Sidebar from "../../component/sidebar/Sidebar"; // Replaced with inline sidebar
// import Navebar from "../../component/navbar/Navbar"; // Replaced with new header
import DocForEmail from "../../component/docForEmail/docForEmail";
import Button from '@mui/material/Button';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'; 
import Chip from '@mui/material/Chip';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import { getClientDisplayEmail } from '../../utils/clientDisplayEmail';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// Icons
import { 
  ArrowLeft, 
  Share2,
  X,
  Clipboard,
  Check,
} from 'lucide-react';

const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS

export default function Fake() {
  const navigate = useNavigate();
  const { id } = useParams();

  // State
  const [isEditing, setIsEditing] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [data, setData] = useState();
  const [note, setNote] = useState('');
  const [value, setValue] = useState(0); // Tab index: 0=Docs, 1=Info, 2=Notes, 3=Activity
  
  // Share Progress Modal
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);

  // Legacy email states (kept for backend compatibility)
  const [openEmailConfirmation, setOpenEmailConfirmation] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  
  // Old "Request New Doc" states (kept for compatibility if needed, but UI uses TableDoc logic mostly)
  const [openNewDoc, setOpenNewDoc] = useState(false);
  const [docName, setDocName] = useState("");
  const [docDescription, setDocDescription] = useState("");
  const [deadline, setDeadline] = useState("");
  const [warningDate, setWarningDate] = useState(false);
  const [toggleNewDoc, setToggleNewDoc] = useState(false);
  const [docNewName, setNewDocName] = useState("");
  const [docNewDes, setNewDocDes] = useState("");
  
  // Edit Name State
  const [toggle, setToggle] = useState(false);
  const [clientNewName, setNewName] = useState("");
  const [buttonText, setNewText] = useState("Edit name");

  // --- Handlers ---

  const handleClickOpenDate = () => setOpenDate(true);
  const handleCloseDate = () => setOpenDate(false);

  const handleModifyClick = () => setIsEditing(true);
  const handleNoteChange = (e) => setNote(e.target.value);

  const handleSaveClick = async () => {
    try {
      await Axios({
          method: "PUT",
          withCredentials: true,
          data: {
            note: note, 
            client_id: data.clients[clientIndice]._id, 
          },
        url: `${backEndUrl}/updateClient/note/` 
      })
    } catch (error) {}
    setIsEditing(false);
  };

  const handleClickOpenEmailConfirmation = () => setOpenEmailConfirmation(true);
  const handleCloseEmailConfirmation = () => {
    setOpenEmailConfirmation(false);
    setEmailSent(false);
  };

  const handleClickOpenNewDoc = () => {
    const currentDate = dayjs.utc();
    setDeadline(dayjs.utc(data.clients[clientIndice].dateDeadline));
    if (currentDate.isAfter(data.clients[clientIndice].dateDeadline)) {
      setWarningDate(true);
      } else {
        setWarningDate(false);
      }
    setOpenNewDoc(true);
  };

  const handleCloseNewDoc = () => setOpenNewDoc(false);

  const handleDateChange = (date) => setDeadline(date);

  // API Calls
  useEffect(() => {
    Axios({
      method: "GET",
      withCredentials: true,
      url: `${backEndUrl}/auth`,
    }).then((res) => {
      setData(res.data);
    });
  }, []);

  useEffect(() => {
    if (data) {
      const client = data.clients.find(client => client._id === id);
      if (client) {
        setNote(client.note);
      }
    }
  }, [data, id]);

  useEffect(() => {
    // Update lastViewed
    Axios.put(`${backEndUrl}/updateClient/updateLastViewed/${id}`, { 
      lastViewed: new Date() 
    }, { withCredentials: true }); 
  }, [id]);

  if (data === undefined) {
    return (
      <div className="flex h-screen items-center justify-center">  
        <CircularProgress color="primary" />
      </div>  
    );
  }

  if (!data) {
    return <h1>Not allowed</h1>;
  }

  // Find Client Index
  let clientIndice = -1;
  for (let i = 0; i < data.clients.length; i++) {
    if (data.clients[i]._id === id) {
      clientIndice = i;
      break;
    }
  }

  if (clientIndice === -1) return <div>Client not found</div>;

  const client = data.clients[clientIndice];
  const notUploadedDocs = client.documents.filter(doc => doc.status === 'not uploaded');

  // Logic functions
  const sendEmailMissingDoc = async () => {
    try {
      const response = await Axios({
        method: "POST",
        withCredentials: true,
        data: {
          client_name: client.client_firstName + " " + client.client_lastName, 
          client_email: client.client_Email,
          consultant_email: data.email,
          missing_doc : notUploadedDocs,
          deadline: new Date(client.dateDeadline).toLocaleDateString('en-GB'),
          language: client.language,
        },
        url: `${backEndUrl}/updateClient/sendEmailMissing`,
      });
      if (response.status === 200) {
        setEmailSent(true);
        setTimeout(() => {
          setEmailSent(false);
          setOpenEmailConfirmation(false); // Close dialog
          // window.location.reload(); 
        }, 2000);
      }
    } catch (error) {}
  };

const changeDeadline = async () => {
  try {
    const today = new Date();
    const selectedDateObject = new Date(deadline);

    if (selectedDateObject < today) {
      alert("Please select a date after today.");
        return;
    }

      await Axios({
        method: "PUT",
        withCredentials: true,
        data: {
          newDate: selectedDateObject, 
          client_id: client._id, 
          status: client.fileStatus
        },
        url: `${backEndUrl}/updateClient/deadlineChange/`
    }).then(() => {
    window.location.reload();
    })
    } catch (error) {}
  };

  const askNewDocAndSendEmail = () => {
     // Kept for compatibility if triggered
     // ... logic as before ...
     // For now, simpler to rely on TableDoc for adding docs.
     // But if this is called from the dialog:
     const newDocObj = {
        "name": docName,
        "description": docDescription,
        // ...
        "status": "not uploaded",
     };
     
     const tempDocs = [newDocObj]; // send just this one

     setOpenNewDoc(false);

     Axios.post(`${backEndUrl}/updateClient/askNewDocAndSendEmail`, {
        doc_name: tempDocs, // API expects array?
        client_id: client._id,
        deadline: new Date(deadline).toLocaleDateString('en-GB'),
        client_name: client.client_firstName + " " + client.client_lastName, 
        client_email: client.client_Email,
                  consultant_email: data.email,
      },
      { withCredentials: true })
      .then(response => {
          if (response.status === 200) {
              window.location.reload();
        }
      })
      .catch(error => console.error("Error:", error));
  }
  
  // Share Progress copy handler
  const handleCopy = () => {
    const missingDocs = client.documents.filter(doc => doc.status === 'not uploaded');
    const isFrench = client.language === 'french';
    const getName = (d) => {
      if (!d.name) return '';
      if (typeof d.name === 'object') return isFrench ? d.name.fr : d.name.en;
      return d.name;
    };
    const getDesc = (d) => {
      if (!d.description) return '';
      if (typeof d.description === 'object') return isFrench ? d.description.fr : d.description.en;
      return d.description;
    };
    const docList = missingDocs.map(d => {
      const name = getName(d);
      const desc = getDesc(d);
      return `• ${name}${desc ? `\n  ${desc}` : ''}`;
    }).join('\n');
    const message = isFrench
      ? `Bonjour ${client.client_firstName},\n\nNous n'avons pas encore reçu les documents suivants pour votre ${client.program || 'dossier'} :\n\n${docList || '• Aucun document manquant'}\n\nVeuillez les télécharger sur le portail dès que possible.\n\nCordialement,`
      : `Hi ${client.client_firstName},\n\nWe are still missing the following documents for your ${client.program || 'application'}:\n\n${docList || '• No missing documents'}\n\nPlease upload them to the portal as soon as possible.\n\nBest regards,`;
    navigator.clipboard.writeText(message).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  // Status Color Logic
  let statusColor = "bg-blue-100 text-blue-700";
  if (client.fileStatus === "uncomplete") statusColor = "bg-amber-100 text-amber-700";
  if (client.fileStatus === "complete") statusColor = "bg-emerald-100 text-emerald-700";
  if (client.fileStatus === "late") statusColor = "bg-red-100 text-red-700";

  function displayDocumentsMissing(doc) {
    return <DocForEmail key={doc._id || doc.name} {...doc} />
  }

        return (
    <div className="flex h-screen bg-slate-50 overflow-hidden font-sans">

        {/* MAIN CONTENT */}
        <main className="flex-1 flex flex-col overflow-hidden">
            
            {/* HEADER */}
            <header className="bg-white border-b border-slate-200 px-12 py-6 sticky top-0 z-20">
                <div className="flex justify-between items-start">
                    <div className="flex items-center gap-4 ">
                        <button onClick={() => navigate(-1)} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-slate-200 transition">
                            <ArrowLeft className="h-4 w-4" />
                        </button>
                        <div  className="ml-3 ">
                            <div className="flex items-center gap-3 ">
                                <h1 className="text-2xl font-bold text-slate-900 leading-none mt-5">{client.client_firstName} {client.client_lastName}</h1>
                                <span className={`px-2 py-0.5 rounded text-xs font-bold uppercase ${statusColor}`}>
                                    {client.fileStatus === 'uncomplete' ? 'Incomplete' : client.fileStatus || "Uknown"}
                                </span>
                            </div>
                            <p className="text-sm text-slate-500 mt-1 flex items-center gap-2">
                                {client.program && (
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-700  border-blue-100">
                                        {client.program}
                                    </span>
                                )}
                                {client.dateDeadline && (() => {
                                    const daysLeft = dayjs(client.dateDeadline).diff(dayjs(), 'day');
                                    return (
                                        <span
                                            className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded cursor-pointer hover:opacity-80 transition"
                                            onClick={handleClickOpenDate}
                                            title="Click to change deadline"
                                        >
                                            {daysLeft < 0 ? `${Math.abs(daysLeft)} days late` : `${daysLeft} days left`}
                                        </span>
                                    );
                                })()}
                                {!client.dateDeadline && (
                                    <span className="text-xs bg-slate-100 px-1.5 py-0.5 rounded cursor-pointer hover:opacity-80 text-slate-500 transition" onClick={handleClickOpenDate}>
                                        Set deadline
                                    </span>
                                )}
                            </p>
                        </div>
      </div>
             
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => setShowShareModal(true)}
                            className="bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 rounded-lg font-bold flex items-center gap-2 transition transform hover:-translate-y-0.5 shadow-lg"
                        >
                            <Share2 className="h-4 w-4" /> Share Progress
                        </button>
                    </div>
                </div>

                <div className="flex gap-8 mt-8">
                    {['Documents', 'Forms', 'Information', 'Notes'].map((tab, idx) => (
                        <button
                            key={tab}
                            onClick={() => setValue(idx)}
                            className={`pb-3 border-b-2 font-medium text-sm transition-colors ${value === idx ? 'border-blue-600 text-blue-600 font-bold' : 'border-transparent text-slate-500 hover:text-slate-700'}`}
                        >
                            {tab} {tab === 'Documents' && `(${client.documents.length})`}
                            {tab === 'Forms' && `(${(client.formsAssigned || []).length})`}
                        </button>
                    ))}
                </div>
            </header>

            {/* DOCUMENT LIST / CONTENT */}
            <div className="flex-1 overflow-y-auto p-8 bg-slate-50">
                <div className="max-w-6xl mx-auto">
                    
                    {/* TAB 0: DOCUMENTS */}
                    {value === 0 && (
<TableDoc 
                            clients={client.documents}
                            deadline={client.dateDeadline}
              rid={data.id}
              getRowId={(row) => row.data.clients._id}
                            ridi={client._id}
              storageUsed={data.storageUsed}
                            isDemo={client.isDemo || false}
                        />
                    )}

                    {/* TAB 1: FORMS */}
                    {value === 1 && (
                        <TableForm
                            forms={client.formsAssigned || []}
                            clientId={client._id}
                        />
                    )}

                    {/* TAB 2: INFORMATION */}
                    {value === 2 && (
                        <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 overflow-hidden">
                            <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50">
                                <h3 className="font-bold text-sm text-slate-700 uppercase tracking-wider">Client Details</h3>
</div> 
                            <div className="p-6">
                                <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                                    {[
                                        ['First name', client.client_firstName],
                                        ['Last name', client.client_lastName],
                                        ['Email', getClientDisplayEmail(client)],
                                        ['Phone', client.phoneNumber],
                                        ['Username', client.client_Username],
                                        ['Password', client.client_Password],
                                        ['Language', client.language],
                                    ].map(([label, val]) => (
                                        <div key={label} className="sm:col-span-1">
                                            <dt className="text-sm font-medium text-slate-500">{label}</dt>
                                            <dd className="mt-1 text-sm text-slate-900 font-semibold">{val || "-"}</dd>
                </div>
                                    ))}
              </dl>
            </div>
            </div>
                    )}

                    {/* TAB 3: NOTES */}
                    {value === 3 && (
                        <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 overflow-hidden h-full min-h-[400px] flex flex-col">
                            <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/50 flex justify-between items-center">
                                <h3 className="font-bold text-sm text-slate-700 uppercase tracking-wider">Notes</h3>
                                {!isEditing && (
                                    <button onClick={handleModifyClick} className="text-blue-600 text-sm font-bold hover:underline">Edit Notes</button>
                                )}
</div>
                            <div className="p-6 flex-1">
{isEditing ? (
                                    <div className="flex flex-col h-full gap-4">
                                        <textarea
                                            className="w-full h-full p-4 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none"
    value={note}
    onChange={handleNoteChange}
                                            placeholder="Add notes here..."
                                        />
                                        <div className="flex justify-end gap-3">
                                            <button onClick={() => setIsEditing(false)} className="px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg">Cancel</button>
                                            <button onClick={handleSaveClick} className="px-4 py-2 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-lg">Save Notes</button>
</div>
</div>
) : (
                                    <div className="prose prose-sm max-w-none text-slate-700 whitespace-pre-wrap">
                                        {note || "No notes available."}
</div>
)}
</div>
</div>
                    )}
                    
                </div>
</div>
        </main>

        {/* --- DIALOGS (Hidden, functionality preserved) --- */}
          
        {/* DATE PICKER DIALOG */}
          <Dialog open={openDate} onClose={handleCloseDate}>
            <DialogTitle>Select a Deadline</DialogTitle>
                <DialogContent>
                <div className="mt-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={deadline ? dayjs(deadline) : null}
                            onChange={handleDateChange}
                            format="YYYY/MM/DD"
                            slotProps={{ textField: { fullWidth: true } }}
                        />
                    </LocalizationProvider>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDate}>Cancel</Button>
                <Button onClick={changeDeadline} variant="contained">Update</Button>
            </DialogActions>
        </Dialog>

        {/* SHARE PROGRESS MODAL */}
        {showShareModal && (() => {
          const missingDocs = client.documents.filter(doc => doc.status === 'not uploaded');
          return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-slate-900/40 backdrop-blur-sm">
              <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl flex flex-col max-h-[90vh]">
                <div className="p-8 flex justify-between items-center flex-shrink-0">
                  <div className="text-left">
                    <h3 className="text-xl font-black text-slate-900">Share Progress</h3>
                    <p className="text-xs text-slate-400 font-medium mt-0.5">Format a message for your client</p>
                  </div>
                  <button onClick={() => { setShowShareModal(false); setCopied(false); }} className="p-2 hover:bg-slate-100 rounded-full text-slate-400 transition">
                    <X className="h-5 w-5" />
                  </button>
                </div>

                <div className="p-8 overflow-y-auto flex-1">
                  <div className="bg-slate-50 rounded-2xl p-6 border-slate-100 text-left relative group">
                    <div className="absolute top-4 right-4 text-[10px] font-black text-indigo-400 uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">Preview</div>
                    <p className="text-sm text-slate-600 whitespace-pre-wrap leading-relaxed font-medium">
                      {client.language === 'french'
                        ? `Bonjour ${client.client_firstName},\n\nNous n'avons pas encore reçu les documents suivants pour votre ${client.program || 'dossier'} :\n\n`
                        : `Hi ${client.client_firstName},\n\nWe are still missing the following documents for your ${client.program || 'application'}:\n\n`
                      }
                      {missingDocs.length > 0
                        ? missingDocs.map(d => {
                            const isFrench = client.language === 'french';
                            const name = d.name
                              ? (typeof d.name === 'object' ? (isFrench ? d.name.fr : d.name.en) : d.name)
                              : '';
                            const desc = d.description
                              ? (typeof d.description === 'object' ? (isFrench ? d.description.fr : d.description.en) : d.description)
                              : null;
                            return (
                              <span key={d._id || name} className="block">
                                • {name}
                                {desc && <span className="block pl-4 text-slate-400 font-normal">{desc}</span>}
                              </span>
                            );
                          })
                        : <span className="block text-slate-400 italic">{client.language === 'french' ? '• Aucun document manquant' : '• No missing documents'}</span>
                      }
                      {client.language === 'french'
                        ? `\n\nVeuillez les télécharger sur le portail dès que possible.\n\nCordialement,`
                        : `\n\nPlease upload them to the portal as soon as possible.\n\nBest regards,`
                      }
                    </p>
                  </div>
                </div>

                <div className="px-8 pb-8 flex flex-col gap-3 flex-shrink-0">
                  <button
                    onClick={handleCopy}
                    className={`w-full py-4 rounded-2xl font-bold flex items-center justify-center gap-3 transition-all shadow-xl ${
                      copied
                        ? 'bg-emerald-500 text-white shadow-emerald-100'
                        : 'bg-slate-900 text-white shadow-slate-200 hover:bg-slate-800'
                    }`}
                  >
                    {copied
                      ? <><Check className="h-5 w-5" /> Copied to Clipboard</>
                      : <><Clipboard className="h-5 w-5" /> Copy Message</>
                    }
                  </button>
                  <p className="text-[10px] text-slate-400 font-medium italic text-center">
                    Paste this into WhatsApp, WeChat, or your email to notify your client.
                  </p>
                </div>
              </div>
            </div>
          );
        })()}

         {/* LEGACY NEW DOC DIALOG (Used if triggered manually, though TableDoc has its own) */}
         <Dialog open={openNewDoc} onClose={handleCloseNewDoc}>
            <DialogTitle>Request New Document</DialogTitle>
            <DialogContent>
                <DialogContentText className="mb-4">Enter details for the new document request.</DialogContentText>
                <TextField
                    autoFocus margin="dense" label="Document Name" fullWidth variant="standard"
                    onChange={e => setDocName(e.target.value)}
                />
                <TextField
                    margin="dense" label="Requirements" fullWidth multiline variant="standard"
                    onChange={e => setDocDescription(e.target.value)}
                />
                <div className="mt-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                         <DatePicker label="Deadline" value={deadline} onChange={handleDateChange} />
                    </LocalizationProvider>
            </div>
                {warningDate && <p className="text-red-500 text-xs mt-2">Warning: Deadline is in the past.</p>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseNewDoc}>Cancel</Button>
                <Button onClick={askNewDocAndSendEmail} variant="contained">Confirm & Notify</Button>
            </DialogActions>
        </Dialog>
    
        </div>
  );
}
